import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { TicketFilters, TicketTab } from '../services/tickets/ticketService';

interface TicketStore {
  filters: TicketFilters;
  activeTab: TicketTab;
  setFilter: (partial: Partial<TicketFilters>) => void;
  resetFilters: () => void;
  setActiveTab: (tab: TicketTab) => void;
}

const defaultFilters: TicketFilters = {};

export const useTicketStore = create<TicketStore>()(
  persist(
    (set) => ({
      filters: defaultFilters,
      activeTab: 'clientele',
      setFilter: (partial) =>
        set((state) => ({ filters: { ...state.filters, ...partial } })),
      resetFilters: () => set({ filters: defaultFilters }),
      setActiveTab: (tab) => set({ activeTab: tab }),
    }),
    { name: 'cime-ticket-filters' },
  ),
);
